import ComponentName from '@Constant/componentName'

const home = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/agent',
    redirect: {
      name: ComponentName.agent.data
    },
    children: [
      {
        component: () => import('../../views/agent-data/index.vue'),
        path: 'data',
        name: ComponentName.agent.data,
        auth: '*',
        meta: {
          title: '数据看板'
        }
      }
    ]
  }
]

export default home
